document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.hostname.includes("gartenzeit.fr")) return;

  const observer = new MutationObserver(() => {
    const spans = document.querySelectorAll("#soldcounter span");

    spans.forEach((span) => {
      if (
        span.textContent &&
        span.textContent.includes("gekauft in den letzten 30 Tagen")
      ) {
        span.textContent = span.textContent.replace(
          "gekauft in den letzten 30 Tagen",
          "achetés au cours des 30 derniers jours"
        );
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});